// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3IxOu","label":"Section_label__MT15C","contentWrap":"Section_contentWrap__2WSBN","footer":"Section_footer__3Vhvo","footerInner":"Section_footerInner__3hDB_"};